import {PageHead} from "../components/PageHead.tsx";
import {AutoHeightTable} from "../components/table/AutoHeightTable.tsx";
import type {Raid, Raids} from "@/raids/rest/RaidSchema.ts";
import {useRaidColumns} from "@/raids/raidTable/columnsHelper.tsx";
import {useGetRaidList} from "@/raids/rest/RaidQueries.ts";
import {PageFullHeight} from "../layout/PageFullHeight.tsx";
import {useColumnVisibility} from "@/components/table/columnVisibilityHelper.tsx";
import {FilterComponent} from "@/components/table/FilterComponent.tsx";

export function TestList() {
  const {data, isLoading} = useGetRaidList();

  function showRecord(raid: Raid) {
    // Row selection is now handled internally by AutoHeightTable
    // This function can be used for additional logic if needed
    console.log("Selected raid:", raid);
  }

  const columns = useRaidColumns();
  const {visibleColumns, toggleComponent} = useColumnVisibility(columns, "test-raid-list");

  const filter = <FilterComponent columnToggle={toggleComponent} />;

  return (
      <PageFullHeight
          title={
            <PageHead
                title={"Test-liste"}
            />
          }
      >
        <AutoHeightTable<Raid>
            data={data as Raids}
            loading={isLoading}
            columns={visibleColumns}
            rowKey="id"
            enableVirtual={true}
            rowClassName={"cursor-pointer"}
            enableRowSelection={true}
            beforeComponent={filter}
            onRow={(raid) => ({
              onClick: () => showRecord(raid),
            })}
        />
      </PageFullHeight>
  );
}
